import { Component } from "react";
import { WarningOctagonIcon, ArrowClockwiseIcon } from "@phosphor-icons/react";

export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("App error boundary caught:", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div data-testid="app-error-boundary" className="min-h-[70vh] flex flex-col items-center justify-center gap-5 px-6 text-center">
          <div className="w-14 h-14 flex items-center justify-center border border-danger/40 bg-danger/10 text-danger">
            <WarningOctagonIcon size={28} weight="fill" />
          </div>
          <div>
            <h1 className="font-heading font-black text-2xl tracking-tighter">Something glitched</h1>
            <p className="text-muted-foreground text-sm mt-2 max-w-sm">A part of AlphaApeing hit a snag. Reload to jump back in — your data is safe.</p>
          </div>
          <button
            data-testid="error-reload-btn"
            onClick={() => window.location.assign("/")}
            className="flex items-center gap-2 px-5 py-2.5 bg-neon text-black font-semibold text-sm hover:bg-neon/90 transition-colors"
          >
            <ArrowClockwiseIcon size={16} weight="bold" /> Reload AlphaApeing
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
